import { Box, Checkbox, FormControlLabel, Grid, Input } from "@mui/material";
import { FormEditUsers } from "components/Forms/FormEditUsers";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useFormEditUsers } from "hooks/useFormEditUsers";
import Error404 from "pages/404";
import Cargando from "pages/Cargando";

export const FormDataFamily = () => {
  const {
    localidades,
    localidad,
    register,
    handleSubmit,
    errors,
    handleLocalidad,
    onSubmit,
    isLoading,
    familyData,
  } = useFormEditUsers();

  if (isLoading) return <Cargando />;
  if (!familyData) return <Error404 />;
  return (
    <DashboardLayout>
      <h1>Datos de familia aliada</h1>
      <FormEditUsers
        localidades={localidades}
        localidad={localidad}
        register={register}
        handleSubmit={handleSubmit}
        errors={errors}
        handleLocalidad={handleLocalidad}
        onSubmit={onSubmit}
        familyData={familyData}
      >
        <Box marginY={2} marginX={2}>
        <Input
              type="hidden"
              defaultValue={familyData?.id}
              {...register("id", {
                required: true,
              })}
            />
          <Grid item xs={12}>
            <MDInput
              type="text"
              label="Cantidad de integrantes"
              defaultValue={familyData?.cantidad}
              {...register("cantidad", {
                required: true,
                min: 1,
                pattern: /^[0-9]+$/i,
              })}
            />
            {errors.apellido?.type === "required" && (
              <MDTypography color="error">Cantidad de integrantes es obligatorio</MDTypography>
            )}
            {errors.apellido?.type === "pattern" && (
              <MDTypography color="error">Caracteres invalidos, solo acepta numeros</MDTypography>
            )}
          </Grid>
          <Grid item xs={12}>
            <p>Programa</p>
            <FormControlLabel
              control={
                <Checkbox {...register("ovitrampa")} defaultChecked={familyData?.ovitrampa} />
              }
              label="Ovitrampa"
            />
            {familyData?.codigo_ovitrampa && (
              <MDInput
                type="text"
                label="Código Ovitrampa"
                defaultValue={familyData?.codigo_ovitrampa}
                {...register("codigo_ovitrampa", { required: true, pattern: /^[O]?-[0-9]+$/i })}
                disabled={false}
              />
            )}
            <FormControlLabel
              control={<Checkbox {...register("kit")} defaultChecked={familyData?.kit} />}
              label="Aspersor"
            />
            {familyData?.codigo_aspersor && (
              <MDInput
                type="text"
                label="Código Aspersor"
                defaultValue={familyData?.codigo_aspersor}
                disabled={false}
              />
            )}
          </Grid>
        </Box>
      </FormEditUsers>
    </DashboardLayout>
  );
};
